// src/utils/rakve.js
import { SKLAD_RAKVI } from "../data/skladRakvi";

const num = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export function najdiRakev({ id = "", nazev = "" } = {}, skladRakvi = []) {
  const sklad = Array.isArray(skladRakvi) && skladRakvi.length ? skladRakvi : SKLAD_RAKVI;
  const sid = String(id || "").trim();
  const sn = String(nazev || "").trim().toLowerCase();

  if (sid) {
    const byId = sklad.find((r) => String(r.id) === sid || String(r.kod) === sid);
    if (byId) return byId;
  }
  if (sn) {
    const byName = sklad.find((r) => String(r.nazev || "").trim().toLowerCase() === sn);
    if (byName) return byName;
  }
  return null;
}

export function spoctiRakevCeny({ id = "", nazev = "", cenaBezDPH, sazbaDPH } = {}, skladRakvi = []) {
  const bez = num(cenaBezDPH);
  const saz = num(sazbaDPH) || 12;

  // 1) preferuj hodnoty z kontextu
  if (bez > 0) {
    const dph = Math.round(bez * (saz / 100) * 100) / 100;
    const s = Math.round((bez + dph) * 100) / 100;
    return { cenaBezDPH: bez, sazbaDPH: saz, dph, cenaSDPH: s };
  }

  // 2) fallback ze skladu/ceníku
  const r = najdiRakev({ id, nazev }, skladRakvi);
  const b = num(r?.cenaBezDPH);
  const sz = num(r?.sazbaDPH ?? 12) || 12;
  const dph = Math.round(b * (sz / 100) * 100) / 100;
  const s = Math.round((b + dph) * 100) / 100;
  return { cenaBezDPH: b, sazbaDPH: sz, dph, cenaSDPH: s };
}
